import { NgModule } from "@angular/core";
import { BrandImgPipe } from "./brand-img.pipe";
import { BrandImgByMidPipe } from "./brand-img-by-mid.pipe";

@NgModule({
  declarations: [BrandImgPipe, BrandImgByMidPipe],
  exports: [BrandImgPipe, BrandImgByMidPipe],
})
export class BrandImgPipeModule {}
